// extracted by mini-css-extract-plugin
export default {"DevPanel":"Xr9AbOcyJ2WHJm7p5Ba_"};